<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  
  <div v-else class="app-container">
    <!-- Header -->
    <header class="app-header">
      <div class="header-content">
        <div class="back-button" @click="goBack()">
         <i class="bi bi-arrow-left-circle-fill"></i>
        </div>
        <div class="header-title">
          <h2>{{ language?.assigned_exams || 'Assigned Exams' }}</h2>
        </div>
        <div class="header-action">
         
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
     
     <div class="staff-section">
  <div class="section-header mb-3">
    <!-- <p class="staff-count">{{ seassionlist.length }} Seassion</p> -->
  </div>

  <!-- Empty State -->
  <div v-if="seassionlist?.length === 0" class="empty-state text-center py-5">
    <div class="empty-icon mb-3">
      <i class="bi bi-clipboard-x fs-1 text-muted"></i>
    </div>
    <h5>No Seassion added</h5>
    <!-- <p class="text-muted">Add Question to get started</p> -->
  </div>

  <!-- Table -->
<div v-else >
  <div class="container">
      <div class="d-flex justify-content-center" v-if="scoredetails.length > 0">
        <div class="card shadow-lg rounded-4 p-2 w-100">
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Score Obtained</h4>
            <button class="print-btn" @click="printCertificate">
                 Show Certificate
                </button>
            <button class="btn btn-outline-secondary btn-sm" @click="goBack">Back</button>
          </div>

          <div class="card-body" style="max-height:500px; overflow-y:auto; overflow-x:hidden;">

        <div class="result-wrapper" v-if="scoredetails && scoredetails.length">

    <!-- Result Summary (sirf ek baar) -->
    <div class="result-summary">
        <h5>Result Summary</h5>
        <div><strong>Student:</strong> {{ scoredetails[0].student_name }}</div>
        <div><strong>Exam:</strong> {{ scoredetails[0].exam_name }}</div>
        <div><strong>Exam Type:</strong> {{ scoredetails[0].exam_type_name }}</div>
        <div><strong>Subject:</strong> {{ scoredetails[0].subject_name }}</div>
    </div>

    <!-- Question Wise Result (MULTIPLE ROWS) -->
    <div
        v-for="(q, index) in scoredetails"
        :key="q.id"
        class="result-card"
    >

        <div class="question">
        <strong>Q{{ index + 1 }}.</strong> {{ q.questiontype }}
        </div>

        <div class="answers">
        <div><strong>Your Answer:</strong> {{ q.selected }}</div>
        <div><strong>Correct Answer:</strong> {{ q.answer }}</div>
        </div>

        <div class="result-footer">
        <span
            class="status"
            :class="q.correct_flag == 1 ? 'correct' : 'wrong'"
        >
            {{ q.correct_flag == 1 ? 'Correct' : 'Wrong' }}
        </span>

        <span class="marks">
            Marks: {{ q.correct_flag == 1 ? q.marks : 0 }}
        </span>
        </div>

    </div>



 <div class="total-summary">
    <div>
      <strong>Total Marks:</strong>
      {{
        scoredetails.reduce((sum, q) => sum + Number(q.marks), 0)
      }}
    </div>

    <div>
      <strong>Obtained Marks:</strong>
      {{
        scoredetails.reduce(
          (sum, q) => sum + (q.correct_flag == 1 ? Number(q.marks) : 0),
          0
        )
      }}
    </div>
  </div>










    </div>





                <div>
                </div>













          </div>

        </div>
      </div>

      <div v-else>
        <span class="text-center text-danger">*No Result Found</span>
        </div>

    </div>






</div>






</div>






<div
  class="modal fade show d-block"
  tabindex="-1"
  v-if="showVideoModal"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Video Preview</h5>
        <button type="button" class="btn-close" @click="closeVideo"></button>
      </div>

      <div class="modal-body text-center">
        <video
          v-if="currentVideo"
          :src="$hostname + 'uploads/video/' + currentVideo"
          controls
          style="width:100%;max-height:400px"
        ></video>
      </div>

    </div>
  </div>
</div>

 













      
    </main>

    



  </div>
</template>


<script> 
import axios from "@/plugins/stdaxios";  

export default {
  name: 'newsession',
  mounted() { 

    if(this.$route.query.id){
    this.getSessions(this.$route.query.id);
    this.examtypeid = this.$route.query.id;
    }else{
         this.getSessions();
    }
  },
  data() {
    return {
      loading: true,
      scoredetails: [],
      examtypeid:'',
      studentId: this.$route.query.student_id,
    };
  },
  methods: {
    
    goBack() {
      // this.$router.go(-3);
      // window.history.go(-3);
     this.$router.replace('/StudentAssignedExamView');

    },
    

    async getSessions(id) {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;


        axios.post("getscore", { id: id }).then((response) => {

          self.scoredetails = response.data.scoredetails;
   

        }).then(() => {
          


        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

     printCertificate() {
        var self = this;
              self.$router.push(`/showcertificationView?id=${self.examtypeid}`);
        }






  }
}
</script>

<style scoped>
.card {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.08);
}

.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #c29300 0%, #fc0000 100%);
  color: white;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  font-size: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.back-button:active {
  background: rgba(255, 255, 255, 0.2);
}

.header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-add {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s;
}

.btn-add:active {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(0.95);
}

.main-content {
  padding: 20px 16px;
  padding-bottom: 80px;
}

.section-header {
  margin-bottom: 16px;
}

.section-header h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-count {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.csv-section {
  margin-bottom: 24px;
}

.csv-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.csv-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.csv-icon {
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #4caf50;
}

.csv-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  color: #2c3e50;
}

.csv-info p {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.btn-csv {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-csv:active {
  background: #388e3c;
  transform: scale(0.98);
}

.staff-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.staff-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.staff-card-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.staff-avatar {
  width: 50px;
  height: 50px;
  background: rgba(0, 86, 194, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #0056c2;
  flex-shrink: 0;
}

.staff-info {
  flex: 1;
}

.staff-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.staff-header h4 {
  margin: 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.badge-admin {
  background: rgba(156, 39, 176, 0.1);
  color: #9c27b0;
}

.badge-staff {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.staff-details p {
  margin: 4px 0;
  font-size: 14px;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  gap: 8px;
}

.staff-status {
  margin-top: 8px;
}

.status-indicator {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status-indicator.inactive {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.staff-actions {
  display: flex;
  padding: 0 16px 16px;
  gap: 8px;
  justify-content: flex-end;
}

.btn-action {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-action:active {
  transform: scale(0.95);
}

.btn-action.edit {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.btn-action.delete {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* Offcanvas Styles */
.offcanvas-header {
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
}

.offcanvas-back {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  margin-right: 12px;
}

.offcanvas-back:active {
  background: #f5f7fa;
}

.offcanvas-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.offcanvas-body {
  padding: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.form-control, .form-select {
  width: 100%;
  padding: 2px 5px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-control:focus, .form-select:focus {
  outline: none;
  border-color: #0056c2;
  box-shadow: 0 0 0 3px rgba(0, 86, 194, 0.1);
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}



.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: #0056c2;
  color: white;
}

.btn-primary:active {
  background: #003a75;
}

.btn-secondary {
  background: #f5f7fa;
  color: #7f8c8d;
}

.btn-secondary:active {
  background: #e9ecef;
}

@media (max-width: 480px) {
  .csv-card {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .staff-card-content {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
  
  .staff-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.text-sm{
    font-size: 14px;
}

.card {
  border-radius: 16px;
}
table th {
  font-weight: 600;
}
table td {
  font-size: 15px;
}
@media (max-width: 600px) {
  table td {
    font-size: 13px;
  }
}


/* ===== Wrapper ===== */
.certificate-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #f4f6f8;
}

/* ===== Certificate Card ===== */
.certificate {
  width: 148mm;
  min-height: 210mm;
  background: #ffffff;
  padding: 25px;
  border: 6px double #2c3e50;
  font-family: "Times New Roman", serif;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

/* ===== Header ===== */
.cert-header {
  text-align: center;
}

.cert-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: bold;
}

.cert-header h4 {
  margin-top: 8px;
  font-weight: normal;
}

.cert-line {
  width: 60%;
  height: 2px;
  background: #2c3e50;
  margin: 10px auto;
}

/* ===== Body ===== */
.cert-body {
  text-align: center;
  margin-top: 35px;
  font-size: 16px;
}

.student-name {
  margin: 15px 0;
  font-size: 22px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.exam-name {
  margin: 10px 0;
  font-size: 18px;
}

.exam-type {
  font-style: italic;
  color: #555;
}

.subject,
.marks {
  margin-top: 12px;
}

/* ===== Footer ===== */
.cert-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}

.sign-line {
  width: 120px;
  border-top: 1px solid #000;
  margin-bottom: 5px;
}

.cert-footer span {
  font-size: 14px;
}

.cert-date {
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .certificate {
    width: 100%;
    min-height: auto;
    padding: 18px;
  }

  .cert-header h2 {
    font-size: 18px;
  }

  .student-name {
    font-size: 18px;
  }

  .cert-body {
    font-size: 14px;
  }

  .cert-footer {
    margin-top: 40px;
  }
}

/* ===== Print ===== */
@media print {
  body {
    background: #fff;
  }

  .certificate-wrapper {
    padding: 0;
  }

  .certificate {
    box-shadow: none;
    border: 4px solid #000;
  }
}

.print-btn {
  background: #2c3e50;
  color: #fff;
  border: none;
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

.print-btn:hover {
  background: #1a252f;
}

/* ===== PRINT ONLY CERTIFICATE ===== */
@media print {

  /* Hide everything */
  body * {
    visibility: hidden;
  }

  /* Show only certificate */
  .certificate-wrapper,
  .certificate-wrapper * {
    visibility: visible;
  }

  /* Position certificate properly */
  .certificate-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0;
    background: white;
  }

  /* Remove card & container look */
  .card,
  .card-header,
  .card-body,
  .container {
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Hide buttons */
  .print-btn,
  .btn {
    display: none !important;
  }

  /* Certificate clean print */
  .certificate {
    width: 148mm;
    min-height: 210mm;
    border: 2px solid #000;
    box-shadow: none;
  }
}

.result-wrapper {
  margin-top: 15px;
  font-family: Arial, sans-serif;
}

.result-summary {
  background: #f8f9fa;
  border-left: 5px solid #2c3e50;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 6px;
}

.result-summary h5 {
  margin-bottom: 10px;
  font-weight: bold;
}

.result-card {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 15px;
  background: #fff;
}

.question {
  font-size: 16px;
  margin-bottom: 10px;
}

.answers {
  margin-left: 10px;
  font-size: 14px;
  color: #333;
}

.answers div {
  margin-bottom: 4px;
}

.result-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
}

.status.correct {
  background: #28a745;
}

.status.wrong {
  background: #dc3545;
}

.marks {
  font-weight: bold;
  font-size: 14px;
}

/* Mobile */
@media (max-width: 768px) {
  .question {
    font-size: 15px;
  }

  .answers {
    font-size: 13px;
  }

  .result-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .marks {
    font-size: 13px;
  }
}


.total-summary {
  margin-top: 20px;
  padding: 15px;
  border-top: 2px solid #2c3e50;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .total-summary {
    flex-direction: column;
    gap: 6px;
    font-size: 14px;
  }
}
















</style>